import ReactInputMask, { Props as InputMaskProps } from 'react-input-mask';
import { Container, InputMask } from './styles';
import { forwardRef } from 'react';


export interface InputFieldMaskProps extends InputMaskProps {
    error?: boolean;
    helperText?: string;
    label?: string;
}

const InputFieldMask = forwardRef<ReactInputMask, InputFieldMaskProps>(({ helperText, label, ...rest }, ref) => {
    return (
        <Container>
            {label && <label>{label}</label>}
            <InputMask {...rest} ref={ref}/>
            {helperText && (
                <span>{helperText}</span>
            )}
        </Container>
    );
});

export default InputFieldMask;